import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/Error.svg'


const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "icon"
      }, null, -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Aceptar',
        onClick: _ctx.closeModalError
      }, null, 8, ["onClick"])
    ])
  ]))
}